import { DateField } from '@components/Fields/DateField';
import { FilterBar } from '@components/FilterBar';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { VerticalDivider } from '@components/VerticalDivider';
import { IField } from '@hooks/useField';
import { IModalWindow } from '@hooks/useModalWindow';
import { Grid, IconButton, makeStyles, Typography } from '@material-ui/core';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import PrintIcon from '@material-ui/icons/Print';
import RefreshIcon from '@material-ui/icons/Refresh';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import React from 'react';

export type CaixaFilterProps = {
    dataCaixaField: IField
    creditoModal: IModalWindow
    debitoModal: IModalWindow
    onRefreshClick: VoidFunction
    onPrintClick: VoidFunction
}

export function CaixaFilter ({ dataCaixaField, creditoModal, debitoModal, onRefreshClick, onPrintClick }: CaixaFilterProps) {
    const cls = useStyles();
    
    return (
        <FilterBar>
            <GridItem>
                <Grid container alignItems="center">
                    <GridItem>
                        <Typography className={cls.title}>
                            Caixa do dia 
                        </Typography>
                    </GridItem>

                    <GridItem>
                        <DateField
                            field={dataCaixaField}
                            updateFieldStateOnChange
                            variant="inline"
                            format="dd/MM/yyyy"
                            autoOk
                            fullWidth={false}
                            className={cls.field}
                            inputProps={{
                                style: {
                                    textAlign: 'center'
                                }
                            }}
                        />                    

                    </GridItem>
                </Grid>
            </GridItem>
            
            <GridItem floatRight>
                <HorizontalGrid>
                    <IconButton onClick={onPrintClick}>
                        <PrintIcon color="primary" />
                    </IconButton>
                    
                    <VerticalDivider />

                    <IconButton onClick={creditoModal.open}>
                        <AddCircleIcon style={{color: 'darkgreen'}} />
                    </IconButton>

                    <IconButton onClick={debitoModal.open}>
                        <RemoveCircleIcon color="secondary" />
                    </IconButton>

                    <VerticalDivider />

                    <IconButton onClick={onRefreshClick}>
                        <RefreshIcon color="primary" />
                    </IconButton>
                </HorizontalGrid>
            </GridItem>
        </FilterBar>
    )
}

const useStyles = makeStyles(theme => ({
    title: {
        marginRight: 15,
        fontWeight: 'bold'
    },

    field: {
        width: 100,
    }
}));
